import { render, staticRenderFns } from "./KeycloakHeaderAccount.vue?vue&type=template&id=48f68996"
import script from "./KeycloakHeaderAccount.vue?vue&type=script&lang=js"
export * from "./KeycloakHeaderAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports